/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var product = event.detail.product; // Gives you access to the whole product details
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let customFlkty = {} // do to delete, it is for rao-page-blog-mobile section

/**
 * ----------------------------------------------------------------------------
 * Megamenu Inner Adjustment
 * ----------------------------------------------------------------------------
 **/

document.addEventListener('product:added', function(event) {
  const product = event.detail.product;
  const productPrice = product.price;
  const productId = product.id;
  const productName = product.title;
  const variant = event.detail.variant;
  const countryCode = 'NL';

  const dataLayer = window.dataLayer || [];
  
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: Shopify.currency.active,
      value: productPrice * 0.01,
      items: [
        {
          item_id: productId,
          id: `shopify_${ countryCode }_${ productId }_${ variant.id }`,
          google_business_vertical: 'retail',
          item_name: productName,
        }
      ]
    }
  });
});

window.addEventListener('resize', function() {
  setMegamenuInnerMargin();
});

window.addEventListener('DOMContentLoaded', function() {
  setMegamenuInnerMargin();
});

function setMegamenuInnerMargin() {
  if (window.innerWidth < 1140) {
    return;
  }

  const firstMenuItem = document.querySelector('.Header__MainNav .HorizontalList__Item');
  
  if (!firstMenuItem) {
    return;
  }
  
  const marginLeft = firstMenuItem.getBoundingClientRect().left;
  const megamenuInners = document.querySelectorAll('.MegaMenu__Inner');

  for (const megamenuInner of megamenuInners) {
    megamenuInner.style.margin = `0 auto 0 ${ marginLeft - 10 }px`;
  }
}

/**
 * ----------------------------------------------------------------------------
 * Custom Dropdown Filter
 * ----------------------------------------------------------------------------
 **/

class CustomCollectionFilters extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', function(e) {
            if (!e.target.closest('.collection-filters-form')) {
                this.querySelector('.collection-filters-form').toggleAttribute('hidden');
                this.querySelector('.opener-icon-wrapper').toggleAttribute('open');
                this.querySelector('.collection-filters-content-wrapper').toggleAttribute('open');
            }
        });
    }
}

class CollectionFilterSort extends HTMLElement {
    constructor() {
        super();

        this.isPriceRange = typeof this.dataset.priceRange !== 'undefined';

        this.checkPriceRangeState();
    }

    checkPriceRangeState() {
        if (!this.isPriceRange) {
            return;
        }

        const searchParams = (new URL(window.location)).searchParams;
        const minValue = searchParams.get(this.dataset.minName);
        const maxValue = searchParams.get(this.dataset.maxName);

        if (minValue !== null || maxValue !== null) {
            this.classList.add('active');
        }
    }
}

/**
 * ----------------------------------------------------------------------------
 * Custom Elements Definitions
 * ----------------------------------------------------------------------------
 **/

window.customElements.define('custom-collection-filters', CustomCollectionFilters);
window.customElements.define('collection-filter-sort', CollectionFilterSort);

/**
 * ----------------------------------------------------------------------------
 * Product Page Back Button
 * ----------------------------------------------------------------------------
 **/

 window.addEventListener('DOMContentLoaded', function () {
    const productBackButton = document.querySelector('.Product__Back_Button');

    if (productBackButton) {
        productBackButton.addEventListener('click', function () {
            window.history.back();
        });
    }
});

/**
 * ----------------------------------------------------------------------------
 * Product Item Video Controls
 * ----------------------------------------------------------------------------
 **/

 /*window.addEventListener('DOMContentLoaded', function () {
    const productItems = document.querySelectorAll('.ProductItem__Wrapper');

    for (const item of productItems) {
        const video = item.querySelector('video');

        if (!video) {
            continue;
        }*/

        /*const playButton = item.querySelector('.ProductItem__Play_Wrapper');*/
        /*const overlay = item.querySelector('.ProductItem__Video_Overlay');*/

        /*playButton.addEventListener('click', function () {
            if (video.getAttribute('aria-playing') === 'false') {
                video.setAttribute('aria-playing', 'true');
                playButton.classList.add('playing');
                overlay.classList.remove('playing');

                video.play();
            }
        });*/

        /*overlay.addEventListener('click', function () {
            if (video.getAttribute('aria-playing') === 'true') {
                video.setAttribute('aria-playing', 'false');*/
                /*playButton.classList.remove('playing');*/
                /*overlay.classList.add('playing');
    
                video.pause();
            } else {
                video.setAttribute('aria-playing', 'true');*/
                /*playButton.classList.add('playing');*/
                /*overlay.classList.remove('playing');

                video.play();
            }
        });*/
    /*}
 });*/

const setClassToElement = (el, className) => {
    if (!el || !className) { console.error('setClassToElement => no params'); return }
   
    if (!el.classList.contains(className)) {
        el.classList.add(className)
    }
}
const removeClassFromElement = (el, className) => {
    if (!el || !className) { console.error('removeClassFromElement => no params'); return }
    if (el.classList.contains(className)) {
        el.classList.remove(className)
    }
}

/**
 * ----------------------------------------------------------------------------
 * Mega menu
 * ----------------------------------------------------------------------------
 **/

window.addEventListener('DOMContentLoaded', function() {
  const imageActivators = document.querySelectorAll('.MegaMenu__Item:not(.MegaMenu__ImageLayer) .Linklist__Item');

  for (const activator of imageActivators) {
    activator.addEventListener('mouseover', function() {
      showHideImage(activator);
    });

    showHideImage(activator, 1);
  }

  function showHideImage(activator, setIndex = undefined) {
    let index = undefined;

    if (!setIndex && activator.getAttribute('data-image-index')) {
      index = activator.getAttribute('data-image-index');
    } else {
      index = setIndex;
    }

    if (index) {
      const images = activator.closest('.MegaMenu').querySelectorAll('.MegaMenu__ImageLayer .MegaMenu__Push');

      for (const image of images) {
        const imageIndex = image.getAttribute('data-image-index');

        if (imageIndex) {
          if (Number(imageIndex) === Number(index)) {
            image.setAttribute('data-hidden', 'false');
          } else {
            image.setAttribute('data-hidden', 'true');
          }
        }
      }
    }
  }
});
